import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mbk-locked-deposites.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./mbk-locked-deposites.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/mbk/mbk-locked-deposites.vue?vue&type=script&lang=js
// module id = SznO
// module chunks = 0